import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayService } from '../../services/overlay.service';
import { Store } from '../../store';
import { BasketService } from '../basket.service';

@Component({
    selector: 'app-floating-pill',
    templateUrl: './floating-pill.component.html',
    styleUrls: ['./floating-pill.component.scss']
})
export class FloatingPillComponent implements OnInit {

    constructor(
        private store: Store,
        private basketService: BasketService,
        private overlayService: OverlayService,
        private router: Router,
    ) { }

    ngOnInit(): void {
    }

    orderCreate(type) {
        this.router.navigate(['/order', 'create', 'entry'])
        // this.basketService.createNewBasket();
        // this.overlayService.toggle('orderCreate');
        //   const basketId = this.basketService.getBasketId();
        //   let basket;
        //   this.basketService.getBasket(basketId).subscribe(data => {
        //       basket = data;

        //       this.basketService.saveBasketToStorage(basket);
        //       this.overlayService.toggle('orderCreate');
        //   });

    }
}
